/**
 * Generated by orval v7.3.0 🍺
 * Do not edit manually.
 * Marketplace API
 * OpenAPI spec version: 1.0.0
 */

/**
 * * `alu_dirt` - Alu Dirt
 * `bales_alu` - Bales Alu
 * `bales_briquette` - Bales Briquette
 * `bales_loading` - Bales Loading
 * `bales_pet` - Bales Pet
 * `colour` - Colour
 * `count` - Count
 * `gdrive_claims_data` - Gdrive Claims Data
 * `gdrive_inspection_data` - Gdrive Inspection Data
 * `gravimetric_alu` - Gravimetric Alu
 * `gravimetric_alu_bale` - Gravimetric Alu Bale
 * `gravimetric_alu_weight` - Gravimetric Alu Weight
 * `gravimetric_pet` - Gravimetric Pet
 * `loose_alu` - Loose Alu
 * `loose_pet` - Loose Pet
 * `pet_dirt` - Pet Dirt
 * `sample_manual` - Sample Manual
 * `selfserve` - Selfserve
 * `site_evidence` - Site Evidence
 * `site_material` - Site Material
 * `sops` - Sops
 * `test_holes` - Test Holes
 * `visual_specification` - Visual Specification
 */
export type EncordFolderEnum = (typeof EncordFolderEnum)[keyof typeof EncordFolderEnum];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const EncordFolderEnum = {
  alu_dirt: 'alu_dirt',
  bales_alu: 'bales_alu',
  bales_briquette: 'bales_briquette',
  bales_loading: 'bales_loading',
  bales_pet: 'bales_pet',
  colour: 'colour',
  count: 'count',
  gdrive_claims_data: 'gdrive_claims_data',
  gdrive_inspection_data: 'gdrive_inspection_data',
  gravimetric_alu: 'gravimetric_alu',
  gravimetric_alu_bale: 'gravimetric_alu_bale',
  gravimetric_alu_weight: 'gravimetric_alu_weight',
  gravimetric_pet: 'gravimetric_pet',
  loose_alu: 'loose_alu',
  loose_pet: 'loose_pet',
  pet_dirt: 'pet_dirt',
  sample_manual: 'sample_manual',
  selfserve: 'selfserve',
  site_evidence: 'site_evidence',
  site_material: 'site_material',
  sops: 'sops',
  test_holes: 'test_holes',
  visual_specification: 'visual_specification',
} as const;
